module.exports = __webpack_public_path__ + "static/media/EvenandOddBookCover.0a809bbf.jpg";